import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[printHidden]',
  standalone: true,
})
export class PrintHiddenDirective implements OnInit {
  private styleId = 'print-hidden-style';

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    // Ensure the print style is injected only once
    if (!document.getElementById(this.styleId)) {
      const style = this.renderer.createElement('style');
      this.renderer.setAttribute(style, 'id', this.styleId);
      style.textContent = `
        @media print {
          .print-hidden {
            display: none !important;
          }
        }
      `;
      this.renderer.appendChild(document.head, style);
    }

    // Mark this element as print-hidden
    this.renderer.addClass(this.el.nativeElement, 'print-hidden');
  }
}
